import { ITripRepository } from "domain/contracts/trip.contract";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { TripInputFilter } from "domain/models/trip-input-filter";
import { Trip } from "domain/entities/trip";

class TripRepository implements ITripRepository {


  async getAll(filter: TripInputFilter): Promise<Message<Trip[]>> {
    const response = await httpClient.get(`/trip`, { params: filter });
    return response.data;
  }

  async update(input: Trip): Promise<Message<boolean>> {
    const response = await httpClient.put(`/trip/${input.id}`, {
      data: input,
    });
    return response.data;
  }

}

export default new TripRepository();
